module.exports = __webpack_public_path__ + "static/media/PL.6cb48e9f.svg";